import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation(["pages"]);

  return (
    <section className="relative w-full h-[100vh] min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/400ca482b7a1877ff4b1b98204273014.jpg"
          alt="LNG Tanker"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/60 to-slate-900/30" />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-20">
        <div className="max-w-2xl">
          <span className="inline-block border border-emerald-400/60 text-emerald-300 text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
            {t("pages:home.hero.subtitle")}
          </span>
          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="text-emerald-400">{t("pages:home.hero.title")}</span>{" "}
            <span className="text-white">{t("pages:home.hero.titleHighlight")}</span>
          </h1>
          <p className="text-lg text-slate-300 leading-relaxed mb-10 max-w-xl">
            {t("pages:home.hero.description")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-600 text-white font-semibold px-8 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("pages:home.hero.ctaPrimary")} <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 border border-white/40 hover:border-white text-white font-semibold px-8 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("pages:home.hero.ctaSecondary")}
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}